/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-10 11:13:36
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-09 16:51:35
 * @name: 调用接口
 * @Description: 调用接口
 * @FilePath: \project\src\nestVue\common\api.js
 * @Author: desktop
 */
import { Message } from "element-ui";
const api = class {
  constructor(sets = {}) {
    // 配置项
    // before{Function}: 前置函数回调
    // after{Function}: 后置函数回调
    // toastSuccess{Boolean}: 是否弹出成功提示
    // successMsg{String}: 成功提示,不传或为空时,提示后端返回成功提示,优先级高于后端提示
    // errMsg{String}: 失败提示,不传或为空时,提示后端返回失败提示,优先级高于后端提示
    this.sets = sets;
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: api调用主方法
   * @param {Object} instance 请求实例
   */
  main(instance) {
    instance.defaults.baseURL = process.env.VUE_APP_BASE_API + '/company/';
    this.sets?.before && this.sets.before(instance);
    this.sets?.after && this.sets.after(instance);
    this.messageDeal(instance);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: get方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   */
  get(url, data, instance) {
    this.main(instance);
    return instance.get(url, { params: data });
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: post方式
   * @param {String} url 接口短地址
   * @param {Object} data 请求参数
   * @param {Object} instance 请求实例
   */
  post(url, data, instance) {
    instance.interceptors.request.use(config => {
      config.headers.Accept = 'application/json';
      config.headers['Content-Type'] = 'application/json';
      return config;
    });
    this.main(instance);
    return instance.post(url, data);
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 消息处理
   * @param {Object} instance 待挂载实例
   */
  messageDeal(instance) {
    if (this.sets?.toastSuccess) {
      this.alertMessage(instance);
    } else {
      this.alertError(instance);
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出错误
   * @param {Object} instance 待挂载实例
   */
  alertError(instance) {
    instance.interceptors.response.use(response => {
      return response;
    }, error => {
      Number(error.code) && Message.error(this.sets?.errMsg ? this.sets?.errMsg : error.msg);
      return Promise.reject(error);
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出成功
   * @param {Object} instance 待挂载实例
   */
  alertSuccess(instance) {
    instance.interceptors.response.use(response => {
      Message.success(this.sets?.successMsg ? this.sets.successMsg : response.msg);
      return response;
    }, error => {
      return Promise.reject(error);
    })
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 弹出结果msg
   * @param {Object} instance 待挂载实例
   */
  alertMessage(instance) {
    this.alertSuccess(instance);
    this.alertError(instance);
  }
}
export default api;